const ACTION_COLOR_LIVESITE = "var(--ricos-native-text-color,  var(--ricos-action-color, #116dff))";
const BG_COLOR_LIVESITE = "var(--ricos-native-secondary-bg-color-background-color, rgba(var(--ricos-text-color-low-tuple, 150, 150, 150),.2) )";
const SLIDER_THUMB_VISIBILITY = { hover: "hover", fixed: "fixed" };
const SLIDER_TRACK_SIZE = { small: "small_track", medium: "medium_track" };
const KEYS_CHARCODE = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32
};
export {
  ACTION_COLOR_LIVESITE,
  BG_COLOR_LIVESITE,
  KEYS_CHARCODE,
  SLIDER_THUMB_VISIBILITY,
  SLIDER_TRACK_SIZE
};
//# sourceMappingURL=consts.js.map
